module.exports = __webpack_public_path__ + "img/sponsors-icon.40eadc54.svg";